(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('CloudPBXDialogController', CloudPBXDialogController);

    CloudPBXDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CloudPBX'];

    function CloudPBXDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CloudPBX) {
        var vm = this;

        vm.cloudPBX = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cloudPBX.id !== null) {
                CloudPBX.update(vm.cloudPBX, onSaveSuccess, onSaveError);
            } else {
                CloudPBX.save(vm.cloudPBX, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('telestatApp:cloudPBXUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
